import { render } from "./AccountManagementRequisites.vue?vue&type=template&id=3be475ad&scoped=true"
import script from "./AccountManagementRequisites.vue?vue&type=script&lang=js"
export * from "./AccountManagementRequisites.vue?vue&type=script&lang=js"

import "./AccountManagementRequisites.vue?vue&type=style&index=0&id=3be475ad&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be475ad"]])

export default __exports__